export const initVal = 'all'

export const cityInitVal = '台北市'
export const statusInitVal = 'initial'

export const filterType = {
  store: ['city', 'district', 'channel'],
  product: ['brand', 'name', 'period']
}